import { type StartOrderStatusLiveActivity } from './useOrderStatusLiveActivity.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * NOTE: Order status live activities widget is iOS only.
 */
export const useOrderStatusLiveActivity = () => {
  return { startOrderStatusLiveActivity: startOrderStatusLiveActivityNoOp };
};

const startOrderStatusLiveActivityNoOp: StartOrderStatusLiveActivity = () => {};
